import { render, staticRenderFns } from "./TwoFactor.vue?vue&type=template&id=aceee2b4&"
import script from "./TwoFactor.vue?vue&type=script&lang=js&"
export * from "./TwoFactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports